// extracted by mini-css-extract-plugin
export default {"plane":"Plane_plane__Ea6uY"};